import { format } from "date-fns";

export const UseMilisecondsToDate = (miliseconds, dateFormat) => {
  let milisecondsToDateString = format(new Date(miliseconds), dateFormat);
  return milisecondsToDateString;
};